import React, { useState, useEffect, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Highlighter from 'react-highlight-words';
import { Space, Tag, Table, Button, Input, Select, PageHeader, Row, Col, DatePicker, Spin, message as messageAntd, Statistic, Card , Modal, Alert,Comment ,
  Result, Tooltip,Avatar} from 'antd';
import { AudioOutlined, SearchOutlined, FileExcelOutlined, LoadingOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { useVT } from 'virtualizedtableforantd4';
import moment from 'moment'
import { CSVLink } from "react-csv";
import { currency, formatterMetrico, onlyTwoDigits } from '../helpers/formatter'
import { getGlobalData, changeFilter, getData, resetData, downloadCsvData, cambia_fecha } from '../actions/reports';
import axios from 'axios';
import  ApiArticulos from  '../components/articulos';
import  Formulario from  '../components/form';
import {  getSeguimientoID , getApigetPreordenSas, selectArticulosIntelisis } from '../actions/saveForm';
import { tz } from 'moment-timezone';


const { Search } = Input;
const { Option } = Select;

function TableMetrico(props) {
  
  const history = useHistory();
  const csvLink = useRef()
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [filterData, setFilterData] = useState(null)
  const [registros, setRegistros] = useState(null)
  const [filteredInfo, setFilteredInfo] = useState({})
  const csvData = useSelector(state => state.reports.csvData)
  const csvName = useSelector(state => state.reports.csvName)
  const fecha = useSelector(state => state.reports.fecha)
  const marcas = useSelector(state => state.reports.marcas)
  const reportes = useSelector(state => state.reports.reportes)
  const [unidades, setUnidades] = useState([])
  const loading = useSelector(state => state.reports.loading)
  const idReporte = useSelector(state => state.reports.idReporte)
  const idMarca = useSelector(state => state.reports.idMarca)
  const idUnidad = useSelector(state => state.reports.idUnidad)
  const anio = useSelector(state => state.reports.anio)
  const mes = useSelector(state => state.reports.mes)
  const data = useSelector(state => state.reports.data)
  const extraData = useSelector(state => state.reports.extraData)
  const columnsData = useSelector(state => state.reports.columnsData)
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [articulos, setArticulos] = useState(null);
  const [comentariobd, setComnetarioBD] = useState('');
  const [keyid, setKeyID] = useState(null);

  const datosHistorial = useSelector(state => state.saveForm.info)
  const articulos = useSelector(state => state.saveForm.intelisisArticulos)


  const timerSearch = useRef(null)

  const dispatch = useDispatch();

  const [vt] = useVT(() => ({
    scroll: { y: "70vh" }
  }), [data]);

  useEffect(() => {
    dispatch(resetData())
    loadData()
    return () => clearTimeout(timerSearch)
  }, []);

  function loadData() {

    setFilteredInfo({})
    setSearchText('')
    setFilterData(null)
    setRegistros(null)
    dispatch(getData(props.idReporte, props.idMarca, props.idUnidad, moment().format("YYYY"), moment().format("MM")))

  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('')
  };


  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {

          }}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}>
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        <div>{text}</div>
      ),
  });

  const distinct = (key) => {

    let unique = []
    if (filterData) {
      if (filterData.length > 0) {
        unique = [...new Set(filterData.map(item => item[key]))];
      }
    } else if (registros) {
      if (registros.length > 0) {
        unique = [...new Set(registros.map(item => item[key]))];
      }
    } else {
      unique = [...new Set(data.map(item => item[key]))];
    }



    let filters = []
    for (let i = 0; i < unique.length; i++) {

      filters.push({ text: unique[i], value: unique[i] })

    }
    return filters
  }



   const showModal = (value) =>  {

      setIsModalVisible(true);
      var MovID =  value.os 
      var comenBD = value.comentarios ; 
      setComnetarioBD(comenBD)
      var idOs =  value.key
      setKeyID(idOs)
      dispatch(getSeguimientoID("idseguimiento", idOs))
      // dispatch(getApigetPreordenSas("idorden", MovID))
      dispatch(selectArticulosIntelisis(MovID))



    };


  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };


  const createColumns = (columnsData, data, filteredInfo, filterData, registros) => {
    if (!data) {
      return null
    }
    let _columns = []
    for (let i = 0; i < columnsData.length; i++) {
      let item = columnsData[i]
      let column = {}

      column.dataIndex = item.index

      if (item.width !== 0) {
        column.minWidth = item.width
        column.width = item.width
      }
      if (item.fixed !== "") {
        column.fixed = item.fixed
      }

      switch (item.tipo) {
        case "total":
          let total = 0
          if (filterData) {
            if (filterData.length > 0) {
              total = filterData.length;
            }
          } else if (registros) {
            if (registros.length > 0) {
              total = registros.length;
            }
          } else {
            total = data.length
          }
          column.title = () => {
            return <div style={{ fontWeight: '700' }}>{item.nombre}
              <div style={{ color: 'slategray', fontWeight: '400' }}>({total})</div></div>
          }
          column.className = "m-nowrap large"
          break
        case "sumCurrency":
        case "sum":
          let sum = 0
          if (filterData) {
            if (filterData.length > 0) {
              sum = filterData.map(i => i[item.index]).reduce((prev, next) => prev + next);
            }

          } else if (registros) {
            if (registros.length > 0) {
              sum = registros.map(i => i[item.index]).reduce((prev, next) => prev + next);
            }

          } else if (data.length > 0) {
            sum = data.map(i => i[item.index]).reduce((prev, next) => prev + next);
          }
          sum = item.tipo === "sumCurrency" ? currency.format(sum, 2) : onlyTwoDigits.format(sum)
          column.title = () => {
            return <div style={{ fontWeight: '700' }}>{item.nombre}
              <div style={{ color: 'slategray', fontWeight: '400' }}>({sum})</div>
            </div>
          }
          column.className = "m-nowrap large"
          break
        default:
          column.title = () => {
            return <div style={{ fontWeight: '700' }}>
              {item.nombre}
            </div>
          }
          column.className = "m-nowrap"
          break
      }

      switch (item.sorter) {
        case "number":
          column.sorter = (a, b) => a[item.index] - b[item.index]
          break
        case "date":
          column.render = (text) => (<div> {moment(text, 'YYYY-MM-DD').format('DD/MM/YYYY')} </div>)
          column.sorter = (a, b) => moment(a[item.index]).unix() - moment(b[item.index]).unix()
        default:
          break
      }

      switch (item.filtro) {
        case "distinct":
          column.filters = distinct(item.index)
          column.onFilter = (value, record) => record[item.index].indexOf(value) === 0
          break
        case "search":
          column = { ...column, ...getColumnSearchProps(item.index) }
        default:
          break
      }

      switch (item.formato) {
        case "currency":
          column.render = (text) => (<div> {currency.format(text)} </div>)
          break
        default:
          break
      }

      switch(item.index)
      {
        case "total":
  
          column.render = (text, os ) => (<div> 
            <Tooltip title="Ver Detalles.">
              <a  onClick={() =>
                  showModal(os)
                } >
                {currency.format(text)} 
              </a>
            </Tooltip>
           
            </div>)
        break
        default:
        break
      }


      column.filteredValue = filteredInfo[item.index] || null

      _columns.push(column)
    }
    return _columns;
  }

  const columns = useMemo(() => createColumns(columnsData, data, filteredInfo, filterData, registros), [filterData, columnsData, filteredInfo]);

  function onSearch(value) {
    clearInterval(timerSearch.current)
    timerSearch.current = setTimeout(() => {
      const filter = data.filter(o =>
        Object.keys(o).some(k =>
          String(o[k])
            .toLowerCase()
            .includes(value.toLowerCase())
        )
      );
      value === "" ? setFilterData(null) : setFilterData(filter)
      setRegistros(null)
      setFilteredInfo({})
    }, 600)

  }

  function downloadCSV() {
    dispatch(downloadCsvData()).then(() => {
      csvLink.current.link.click()
    })
  }

  const handleTableChange = (pagination, filters, sorters, extra) => {

    setRegistros(extra.currentDataSource)
    setFilteredInfo(filters)
  }




  const isNumber = (value) => {
    return typeof value === 'number' &&
      isFinite(value);
  }

  function onChangeDate(date, dateString) {

    dispatch(changeFilter('fecha', date))

    loadData()

  }




  return (
    <div style={{ margin: "4px" }}>
      <Spin spinning={loading} tip="Loading..." indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}>
        <PageHeader
          className="m-page-header"
          onBack={() => history.goBack()}
          title={<div style={{ fontSize: "18px" }}>{props.nameMetrico.replace(props.formatMetrico, '')}</div>}
          subTitle={<div style={{ fontSize: "18px", fontWeight: "600" }}>{formatterMetrico(props.valMetrico, props.formatMetrico)}</div>}
          extra={[
            <DatePicker
              key={'3'}
              defaultValue={fecha}
              onChange={onChangeDate}
              placeholder="Periodo"
              style={{ width: 120 }}
              picker="month"
              size={'large'}
            />,
            <Button
              key="0"
              shape="circle"
              type="primary"
              onClick={downloadCSV}
              style={{ background: "green", borderColor: "green" }}>
              <FileExcelOutlined />
            </Button>,
            <CSVLink
              style={{ display: 'none' }}
              ref={csvLink}
              target='_blank'
              filename={csvName}
              key="1"
              data={csvData}>
            </CSVLink>,
            <input
              key="2"
              style={{ border: "1px solid lightslategray", borderRadius: "3px" }}
              placeholder=" Buscar..."
              type="search"
              onChange={(e) => onSearch(e.target.value)} />
          ]} />

        <div>
          <font style={{ color: "black" }}>Registros:</font>
          {filterData ? filterData.length : data ? data.length : 0}
        </div>

        <div>
          <Table
            tableLayout="auto"
            pagination={false}
            scroll={{ y: '70vh' }}
            style={{ marginTop: "32px" }}
            size="small"
            components={vt}
            columns={columns}
            onChange={handleTableChange}
            dataSource=  { filterData ? filterData :  data ? data : [] 
            }
            />
        </div>
            
        <Modal 
          title="Detalles de movimientos."  
          open={isModalVisible} 
          onOk={handleOk} 
          onCancel={handleCancel}
          width={700}
        >

          { 
            articulos != null ? <ApiArticulos  dataArticulos={articulos} /> : <div><Alert message="Api sin Informacion !" type="warning" /></div>
          }
          <br/>
          <h4  style={{textAlign:"left"}}> Comentarios Intelisis: </h4>  <small> { comentariobd } </small>
          <br/>
          <h4  style={{textAlign:"left"}} >Detalle Seguimiento Metrics</h4>
          
          { datosHistorial.map( (item , id)  => {
              return (
                <Row key= {id}>
                   <Col span={12} offset={6}>
                    <Comment
                        author={<a>Fecha:</a>}
                        avatar={<Avatar src="https://www.pavilionweb.com/wp-content/uploads/2017/03/man-300x300.png"  width="150px" alt="user" />}
                        content={
                          <p key={item.id} > { item.comentario  }                             
                          </p>
                        }
                        datetime={
                          <Tooltip 
                            title={moment().format( item.fecha, 'YYYY-MM-DD')}
                            >
                            <span>  
                              {moment().format(item.fecha, "YYYY-MM-DD")} 
                            </span>
                          </Tooltip>
                        }
                      />
                  </Col>
                  
                </Row>
              );
          }) 

          }
       
          <Formulario   idkey={keyid} />


        </Modal>


      </Spin>
    </div>

  );

}

export default TableMetrico;